<template>
  <Select label="Horario" :options="horariosFormateados" :modelValue="horarioSelected" @change="selectHorario" />
</template>
<script setup>
  import { computed } from "vue"
  import Select from "@/components/Select"

  const props = defineProps({
    horarios: {
      type: Array,
      required: true,
    },
    horarioSelected: {
      type: String,
    },
  })

  const horariosFormateados = computed(() => {
    const ff = props.horarios.map((h, index) => {
      return {
        id: index,
        label: h.horario,
        value: h.horario,
        disabled: h.disabled,
      }
    })
    return ff
  })

  const emit = defineEmits({ select: "String" })
  const selectHorario = () => {
    emit("select")
  }
</script>
<style></style>
